import { render, staticRenderFns } from "./ServicesCarousel.vue?vue&type=template&id=4f16ef65&scoped=true&"
import script from "./ServicesCarousel.vue?vue&type=script&lang=ts&"
export * from "./ServicesCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesCarousel.vue?vue&type=style&index=0&id=4f16ef65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f16ef65",
  null
  
)

export default component.exports